/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback, useState } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import ChevronRightIcon from '@atlaskit/icon/utility/migration/chevron-right';
import { Box } from '@atlaskit/primitives/compiled';
import { N50, N200 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	wrapper: {
		paddingInlineEnd: token('space.050', '4px'),
	},
});

export default () => {
	const [isMouseHovered, setHoverState] = useState(false);
	const onMouseEnter = useCallback(() => setHoverState(true), [setHoverState]);
	const onMouseLeave = useCallback(() => setHoverState(false), [setHoverState]);
	return (
		<Box
			role="presentation"
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			xcss={styles.wrapper}
		>
			<ChevronRightIcon
				spacing="spacious"
				testId="chevron-right-icon"
				label="chevron right"
				color={token('color.icon.subtle', isMouseHovered ? N200 : N50)}
				LEGACY_size="large"
				LEGACY_margin={`0 ${token('space.negative.050')} 0 0`}
			/>
		</Box>
	);
};
